


































import { Component, Prop, Vue } from "vue-property-decorator";
import { MaintenanceElementStatus, MaintenanceListElementEntry } from "@/models/maintenanceListElementEntry";

@Component({
  components: {
    MaintenanceListRadio: () => import('./../components/radio/MaintenanceListRadio.component.vue'),
  }
})
export default class MaintenanceListTableRowComponent extends Vue {

  @Prop({ default: () => { } })
  public maintenanceListElementEntry!: MaintenanceListElementEntry;

  @Prop({ default: () => 'editMaintenanceList' })
  public source!: string;

  public elementChanged(value: MaintenanceElementStatus) {
    this.maintenanceListElementEntry.controlStatus = value;
  }

  mounted() {
    if (this.source === 'newChecklist') {

      if (!this.maintenanceListElementEntry.controlStatus) {
        this.maintenanceListElementEntry.controlStatus = MaintenanceElementStatus.checkOkay;
      }


      
    }

  }

  public radioOptions: Array<{
    status: MaintenanceElementStatus,
    text: string
  }> = [{
    status: MaintenanceElementStatus.checkOkay, text: 'i.o.'
  }, {
    status: MaintenanceElementStatus.checkNotOkay, text: 'n.i.o',
  }, {
    status: MaintenanceElementStatus.notRequired, text: 'n.v'
  }];
}
